import React, { useState, useEffect } from 'react'
import { Routes, Route } from 'react-router-dom'
import { toast } from 'react-toastify'
import { jwtDecode } from 'jwt-decode'
import 'react-toastify/dist/ReactToastify.css'
import './App.css'
import {
  getTemplates,
  checkAUth,
  login,
  deleteTenplate,
} from './utils/templatesApi'

import LoginForm from './login'
import GenerateEmail from './pages/AIEmailGeneration'
import Layout from './pages/Layout'
import Templates from './pages/Templates'
import Template from './template'
import Users from './pages/Users/User'
import Category from './pages/Categories'
import DashBoard from './pages/DashBoard'
import EmailValidate from './pages/Email-Validate'
import { EditPromptPage } from './pages/Editprompt'
import Reports from './pages/Reports'

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [reloadTrigger, setReloadTrigger] = useState(false)
  const [templates, setTemplates] = useState([])
  const [template, setTemplate] = useState(null)
  const [decodedToken, setDecodedToken] = useState(null)
  const [heading, setHeading] = React.useState('')

  const getData = () => {
    getTemplates().then(data => {
      setTemplates(data)
    })

    const token = localStorage.getItem('_atk')
    if (token) {
      const decoded = jwtDecode(token);
      setDecodedToken(jwtDecode(token))
      console.log("Decoded Token:", decoded);
      console.log("User Role:", decoded?.role);
    }
  }

  const handleLogin = data => {
    login(data).then(success => {
      if (success) {
        setIsAuthenticated(true)
        getData()
      } else {
        toast.error('Invalid Credentials')
      }
    })
  }

  const handleDelete = async itemToDelete => {
    await deleteTenplate(itemToDelete)
    getData()
    setReloadTrigger(prev => !prev)
  }

  useEffect(() => {
    const auth = checkAUth()
    if (auth) {
      getData()
      setIsAuthenticated(true)
    }
  }, [reloadTrigger])

  return (
    <>
      <Routes>
        {!isAuthenticated ? (
          <Route path='/' element={<LoginForm onSubmit={handleLogin} />} />
        ) : (
          <Route
            element={
              <Layout
                role={decodedToken?.role}
                heading={heading}
                userId={decodedToken?.id}
              />
            }
          >
            {['admin', 'super-admin'].includes(decodedToken?.role) ? (
              <>


                <Route
                  path='/'
                  element={
                    <DashBoard
                      setHeading={setHeading}
                      userId={decodedToken?.id}
                    />
                  }
                />
                <Route
                  path='categories'
                  element={
                    <Category
                      setHeading={setHeading}
                      userId={decodedToken?.id}
                    />
                  }
                />
                <Route
                  path='/:id'
                  element={<Category userId={decodedToken?.id} />}
                />
                <Route
                  path='templates'
                  element={
                    <div className='App'>
                      <Templates
                        items={templates.data}
                        onSelect={setTemplate}
                        onDelete={handleDelete}
                        reloadTrigger={reloadTrigger}
                        role={decodedToken?.role}
                        userId={decodedToken?.id}
                        setHeading={setHeading}
                      />
                      {template && (
                        <Template
                          template={template}
                          onClose={() => setTemplate(null)}
                          open={!!template}
                          onNewAdd={getData}
                          setReloadTrigger={setReloadTrigger}
                          role={decodedToken?.role}
                          userId={decodedToken?.id}
                        />
                      )}
                    </div>
                  }
                />
                <Route
                  path='users'
                  element={<Users setHeading={setHeading} />}
                />
                <Route path='users/:id' element={<Users />} />
                <Route
                  path='email-validate'
                  element={
                    <EmailValidate
                      userId={decodedToken?.id}
                      setHeading={setHeading}
                      role={decodedToken?.role}
                    />
                  }
                />
                <Route
                  path='reports'
                  element={
                    <Reports
                      userId={decodedToken?.id}
                      setHeading={setHeading}
                      role={decodedToken?.role}
                    />
                  }
                />
                <Route
                  path='ai_email_generate'
                  element={
                    <GenerateEmail
                      userId={decodedToken?.id}
                      setHeading={setHeading}
                    />
                  }
                />
                <Route
                  path='edit_prompt'
                  element={
                    <EditPromptPage
                      userId={decodedToken?.id}
                      setHeading={setHeading}
                    />
                  }
                />

                ) : (
                <>
                  <Route
                    path='/'
                    element={
                      <DashBoard
                        setHeading={setHeading}
                        userId={decodedToken?.id}
                      />
                    }
                  />
                  <Route
                    path='categories'
                    element={
                      <Category
                        setHeading={setHeading}
                        userId={decodedToken?.id}
                      />
                    }
                  />
                  <Route
                    path='/:id'
                    element={<Category userId={decodedToken?.id} />}
                  />
                  <Route
                    path='templates'
                    element={
                      <div className='App'>
                        <Templates
                          items={templates.data}
                          onSelect={setTemplate}
                          onDelete={handleDelete}
                          reloadTrigger={reloadTrigger}
                          role={decodedToken?.role}
                          userId={decodedToken?.id}
                          setHeading={setHeading}
                        />
                        {template && (
                          <Template
                            template={template}
                            onClose={() => setTemplate(null)}
                            open={!!template}
                            onNewAdd={getData}
                            setReloadTrigger={setReloadTrigger}
                            role={decodedToken?.role}
                            userId={decodedToken?.id}
                          />
                        )}
                      </div>
                    }
                  />
                  <Route
                    path='email-validate'
                    element={
                      <EmailValidate
                        userId={decodedToken?.id}
                        setHeading={setHeading}
                        role={decodedToken?.role}
                      />
                    }
                  />
                </>
                )
              </>
            ) : (
              <>
                <Route
                  path='/'
                  element={
                    <div className='App'>
                      <Templates
                        items={templates.data}
                        onSelect={setTemplate}
                        onDelete={handleDelete}
                        reloadTrigger={reloadTrigger}
                        role={decodedToken?.role}
                        userId={decodedToken?.id}
                      />
                      {template && (
                        <Template
                          template={template}
                          onClose={() => setTemplate(null)}
                          open={!!template}
                          onNewAdd={getData}
                          setReloadTrigger={setReloadTrigger}
                          role={decodedToken?.role}
                          userId={decodedToken?.id}
                        />
                      )}
                    </div>
                  }
                />
                <Route
                  path='email-validate'
                  element={
                    <EmailValidate
                      userId={decodedToken?.id}
                      setHeading={setHeading}
                      role={decodedToken?.role}
                    />
                  }
                />
                <Route
                  path='ai_email_generate'
                  element={
                    <GenerateEmail
                      userId={decodedToken?.id}
                      setHeading={setHeading}
                    />
                  }
                />
              </>

            )}

          </Route>
        )}
      </Routes>
    </>
  )
}

export default App